<template>
  <a-form
    class="mod-form mod-order-form"
    layout="horizontal"
    labelAlign="left"
    :label-col="labelCol"
    :wrapper-col="wrapperCol"
    :colon="false"
    :form="form"
    @submit="onSubmit"
  >
    <a-form-item :wrapper-col="wrapperColOffset">
      <div style="text-align: center">请输入金鹏卡号密码，以完成绑定</div>
    </a-form-item>
    <a-form-item label="金鹏卡号">
      <a-input
        size="large"
        placeholder="请输入金鹏卡号/手机/身份证号"
        v-decorator="[
          'cid',
          {
            initialValue: cid,
            rules: [
              {
                validator: handleFieldValidate
              }
            ],
            validateTrigger: 'blur'
          }
        ]"
        :disabled="!!cid"
      >
      </a-input>
    </a-form-item>
    <a-form-item label="密码">
      <a-input
        size="large"
        placeholder="请输入密码"
        type="password"
        v-decorator="[
          'loginPwd',
          {
            rules: [
              {
                validator: handleFieldValidate
              }
            ],
            validateTrigger: 'blur'
          }
        ]"
      >
      </a-input>
    </a-form-item>
    <a-form-item label="验证码">
      <user-slider-captcha ref="verify" size="large" @change="onCaptchVerify">
  </user-slider-captcha>
    </a-form-item>
    <a-form-item :wrapper-col="wrapperColOffset">
      <a-button style="margin: 0; width: 100%" type="primary" size="large" :loading="loading" html-type="submit">绑定金鹏卡</a-button>
    </a-form-item>
  </a-form>
</template>

<script>
import { validate } from '@/utils/validate'
import { ffpBinding, ffpBindingRealName } from '@/api/member'

export default {
  props: {
    event: {
      type: Number,
      default: 0
    },
    realNameToken: String
  },
  data () {
    return {
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 19
      },
      wrapperColOffset: {
        span: 19, offset: 5
      },
      form: this.$form.createForm(this),
      loading: false,
      token: '',
      cid: ''
    }
  },
  created () {
    const lsData = this.$ls.get('USER_CENTER_FFP_INFO')

    if (this.event === 1 && lsData) {
      this.cid = lsData.cid
    }
  },
  methods: {
    handleFieldValidate (rule, value, callback) {
      validate('ffp-binding', this.form.getFieldsValue(), rule.fullField).then(({ valid, error }) => {
        if (valid) {
          callback()
        } else {
          callback(error)
        }
      })
    },
    onSubmit (e) {
      e.preventDefault()

      this.form.validateFields(async (errors, values) => {
        if (!errors) {
          try {
            const { token, event, realNameToken } = this

            if (!token) {
              this.$error({
                content: '请拖动滑块完成验证！',
                centered: true,
                okText: '确定'
              })
              return
            }

            this.loading = true

            const params = {
              token,
              data: {
                cid: values.cid,
                loginPwd: values.loginPwd
              }
            }

            if (event === 1) {
              params.realNameToken = realNameToken
              await ffpBindingRealName(params)
            } else {
              await ffpBinding(params)
            }

            this.$success({
              content: '金鹏卡绑定成功',
              centered: true,
              okText: '确定',
              onOk: () => {
                if (event === 1) {
                  this.$ls.remove('USER_CENTER_FFP_INFO')
                  this.$emit('next')
                } else {
                  this.$router.replace('/account')
                }
              }
            })
          } catch (err) {
            if (err.code === 100010090) {
              // 将金鹏卡存入缓存，实名认证中直接带过去
              this.$ls.set('USER_CENTER_FFP_INFO', {
                cid: values.cid
              }, 30 * 60 * 1000)

              this.$error({
                content: err.message,
                centered: true,
                okText: '确定',
                onOk: () => {
                  this.$router.replace({
                    path: '/authenticate',
                    query: {
                      type: 'ffpBinding'
                    }
                  })
                }
              })

              return
            }

            if (err.code === 20062) {
              this.$confirm({
                title: '温馨提示',
                content: err.message,
                centered: true,
                cancelText: '取消',
                okText: '去修改',
                onOk: () => {
                  this.$router.replace({
                    path: '/password',
                    query: {
                      type: 'newChange',
                      cid: values.cid
                    }
                  })
                },
                onCancel: () => {
                  this.$refs.verify.refresh()
                  this.loading = false
                }
              })

              return
            }

            this.$refs.verify.refresh()
            this.$error({
              content: err.message,
              centered: true,
              okText: '确定'
            })
            this.loading = false
          }
        }
      })
    },
    onCaptchVerify (value) {
      this.token = value
    }
  }
}
</script>
